var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('practical-exam-form',{attrs:{"loading":_vm.loading},on:{"on-submit":_vm.onSubmit,"on-close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }